import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import xss from 'xss';
import TitleHeader from '../../components/molecules/TitleHeader/TitleHeader';
import { PATHS } from '../../navigationConstants';
import Button from '../../components/atoms/Button/Button';
import CheckboxInput from '../../components/atoms/CheckboxInput/CheckboxInput';
import { referencingInfoCopy } from '../../content/main.json';
import { WalesContext } from '../../providers/WalesContext';
import { getOcrReferencing, updateOpportunityContactRole } from '../../api/salesforce';

import './ReferencingInfo.scss';
import { UserContext } from '../../providers/UserContext';

const Referencinginfo = () => {
  const { isWales } = useContext(WalesContext);
  const {
    referenceProvider,
    ocrId,
    opportunityId,
    contactId,
  } = useContext(UserContext);
  const [petTermsAgreed, setPetTermsAgreed] = useState(false);
  const [isLoadingPetTerms, setIsLoadingPetTerms] = useState(true);
  const [isSavingPetTerms, setIsSavingPetTerms] = useState(false);

  const referencingInfoTerms = !isWales ? referencingInfoCopy : referencingInfoCopy.wales;
  const descriptionText = Array.isArray(referencingInfoTerms.description)
    ? referencingInfoTerms.description.join(' ')
    : referencingInfoTerms.description;
  const {
    petPolicyConfirmationLabel,
  } = referencingInfoTerms;
  const sanitizedPetPolicyConfirmationLabel = xss(petPolicyConfirmationLabel);

  useEffect(() => {
    let isMounted = true;

    async function fetchExistingPetTerms() {
      if (!opportunityId || !contactId) {
        if (isMounted) {
          setIsLoadingPetTerms(false);
        }
        return;
      }

      try {
        const { petTerms } = await getOcrReferencing(opportunityId, contactId);
        if (isMounted && petTerms) {
          setPetTermsAgreed(true);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Could NOT retrieve existing Pet_Terms__c value');
      } finally {
        if (isMounted) {
          setIsLoadingPetTerms(false);
        }
      }
    }

    fetchExistingPetTerms();

    return () => {
      isMounted = false;
    };
  }, [opportunityId, contactId]);

  const onPetTermsChange = async () => {
    if (isLoadingPetTerms || isSavingPetTerms) {
      return;
    }

    const nextValue = !petTermsAgreed;
    setPetTermsAgreed(nextValue);

    if (!nextValue || !ocrId) {
      return;
    }

    setIsSavingPetTerms(true);
    try {
      await updateOpportunityContactRole(ocrId, { petTerms: new Date().toISOString() });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Could NOT update Pet_Terms__c on OpportunityContactRole');
      setPetTermsAgreed(false);
    } finally {
      setIsSavingPetTerms(false);
    }
  };

  return (
    <div className="referencing-info">
      <TitleHeader
        title={referencingInfoTerms.title}
        large
      />
      {/* eslint-disable-next-line react/no-array-index-key */}
      {referencingInfoTerms.introduction.map((line, index) => <p key={`introduction-${index}`}>{(referenceProvider || '').toLowerCase() === 'homelet' ? line.replace('Rightmove', 'Homelet') : line}</p>)}
      <p>{descriptionText}</p>
      <ul className="referencing-info__list">
        {referencingInfoTerms.info.map(
          (item, index) => <li key={`info-${index}`}>{item}</li>, // eslint-disable-line react/no-array-index-key
        )}
      </ul>
      {referencingInfoTerms.additionalInformation
        && referencingInfoTerms.additionalInformation.map((line) => (
          <p
            key={`additionalInformation-${line}`}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: xss(line) }}
          />
        ))}
      {isLoadingPetTerms ? (
        <p className="referencing-info__petTermsLoader">
          Loading pet policy confirmation
          <span className="referencing-info__loaderDots" aria-hidden="true">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </p>
      ) : (
        <CheckboxInput
          id="petTerms"
          name="petTerms"
          value="petTerms"
          className="referencing-info__petTerms"
          // eslint-disable-next-line react/no-danger
          label={<span dangerouslySetInnerHTML={{ __html: sanitizedPetPolicyConfirmationLabel }} />}
          checked={petTermsAgreed}
          onChange={onPetTermsChange}
        />
      )}
      <br />
      {isLoadingPetTerms ? (
        <Button title={referencingInfoTerms.nextButton} testId="referencing-info-next" disabled />
      ) : (
        <Link to={PATHS.REFERENCING}>
          <Button title={referencingInfoTerms.nextButton} testId="referencing-info-next" />
        </Link>
      )}
    </div>
  );
};

export default Referencinginfo;
